import { Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PrintService } from './services/print.service';
import { ApiService } from './services/api.service';
import { PrintComponent } from './print/print.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @ViewChild(PrintComponent, { static: false }) printComponent!: PrintComponent;

  
  // Router needed for not showing Header in login Example
  router: string;
  constructor(
    private titleService: Title,
    private printService: PrintService,
    private apiService: ApiService,


    ) {

    this.titleService.setTitle('Demokratie kommunal');

  }

  ngOnInit() {
    
  }
}


